var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useRef } from 'react';
import { MapLibreService } from '../services/MapLibreService';
import { mapOptions } from '../config/mapConfig';
export var useMapInstance = function (_a) {
    var container = _a.container, locations = _a.locations, _b = _a.enabled, enabled = _b === void 0 ? false : _b, onError = _a.onError, onInteraction = _a.onInteraction, scrollZoom = _a.scrollZoom, language = _a.language;
    var mapService = useRef(null);
    var initialized = useRef(false);
    useEffect(function () {
        if (!container || !enabled) {
            return;
        }
        if (!mapService.current) {
            mapService.current = new MapLibreService();
        }
        if (!initialized.current) {
            try {
                mapService.current.initialize(container, __assign(__assign({}, mapOptions), { onError: onError, onInteraction: onInteraction, scrollZoom: scrollZoom, language: language }));
                initialized.current = true;
            }
            catch (err) {
                console.error('Map initialization error:', err);
                onError === null || onError === void 0 ? void 0 : onError(err);
            }
        }
        return function () {
            if (mapService.current) {
                mapService.current.cleanup();
                initialized.current = false;
            }
        };
    }, [container, language]);
    useEffect(function () {
        if (!mapService.current || !initialized.current || !locations.length) {
            return;
        }
        try {
            mapService.current.addMarkers(locations);
        }
        catch (err) {
            console.error('Error adding markers:', err);
            onError === null || onError === void 0 ? void 0 : onError(err);
        }
    }, [locations, onError]);
};
